import { isNullish } from '@y42/util/nullish';
import * as go from 'gojs';
import { getPointString, getSizeString } from '../../../../../utils/stringify-utils';
import { LOCATION_PROP, SIZE_PROP } from '../../common/config/common-prop-names';

export const groupMargin = 20;

const calculateGroupBounds = (group: go.Group) => {
  const { width, height } = group.resizeObject.desiredSize;
  const { x, y } = group.position;
  const groupBounds = new go.Rect(x, y, width, height);

  if (group.diagram) {
    return calculateMinGroupBounds(group.diagram, group.memberParts).unionRect(groupBounds);
  } else {
    return new go.Rect(x, y, width, height); // TODO: valid else statement?
  }
};

export const refreshGroupBounds = (group: go.Group) => {
  setGroupBounds(group, calculateGroupBounds(group));
};

export const setGroupBounds = (group: go.Group, { x, y, width, height }: go.Rect) => {
  group.diagram?.commit(() => {
    group.diagram?.model.set(group.data, SIZE_PROP, getSizeString(width, height));

    group.diagram?.model.set(group.data, LOCATION_PROP, getPointString(x, y));
  });
};

export const calculateMinGroupBounds = (diagram: go.Diagram, children: go.Iterator<go.Part>) => {
  const { x, y, width, height } = computePartsBounds(children);

  return new go.Rect(x - groupMargin, y - groupMargin, width + groupMargin * 2, height + groupMargin * 2);
};

export const updateGroupBoundaries = (group: go.Group) => {
  if (group.diagram) {
    const { x, y, width, height } = calculateMinGroupBounds(group.diagram, group.memberParts);
    group.diagram.commit((d) => {
      d.model.set(group.data, SIZE_PROP, getSizeString(width, height));
      d.model.set(group.data, LOCATION_PROP, getPointString(x, y));
    });
  }
};

const computePartsBounds = function (coll: go.Iterator<go.Part>, includeLinks?: boolean) {
  if (!coll.count) {
    return new go.Rect(NaN, NaN, 0, 0);
  }
  let b;
  const iterator = coll.iterator;
  while (iterator.next()) {
    const part = iterator.value;
    if (!!includeLinks || part instanceof go.Link) {
      continue;
    }
    part.ensureBounds();
    const { x, y } = part.actualBounds;
    const { x: sr, y: sy, width, height } = part.selectionObject.actualBounds;
    const rect = new go.Rect(x + sr, y + sy, width, height);
    b = isNullish(b) ? rect : b.unionRect(rect);
  }

  return b || new go.Rect(NaN, NaN, 0, 0);
};
